import PlantSelectorWidget from '../../inplant-coreadapter-fe/ui/components/widgets/PlantSelector/components/PlantSelector/PlantSelectorWidget'

export const widgets = {
  'widget-area-sidebar-bottom': {},
  'widget-area-dashboard-topright': {},
  'widget-area-topbar-right': {
    PlantSelectorWidget
  }
}
